import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Nav, NavLink, NavItem } from "reactstrap";
import {
  Container,
  Paper,
  Button,
  Box,
} from "@mui/material";
import { AddCircleOutlined, FileDownloadRounded, Try} from "@mui/icons-material";
import Moment from "moment";
import AcademyService from "../services/AcademyService";
import { useHistory } from "react-router-dom";
import useDocuments from "../hooks/useDocuments";
import DocumentFilters from "./invoice/DocumentFilters";
import DocumentTable from "./invoice/DocumentTable";

import classnames from "classnames";



const InvoicePage = (props) => {
  const academyService = new AcademyService();
  const history = useHistory();
  Moment.locale('es');
  const { user, campus } = props;
  const valInitials = {
    search: "",
    document_type: "",
    status_sunat: "",
    per_page: 20,
    campus_id: campus.id,
    page: 1,
    sort_by: "id",
    sort_direction: "desc",
    from: "",
    to: "",
  };
  const [activeTab, setActiveTab] = useState(1);
  const [isFilters, setIsFilters] = useState(false);
  const [filters, setFilters] = useState(valInitials);

  const handleClick = () => {
    history.push("/invoices/create"); // Use it here, but define it above
  };

  const handleExport = async() => {
    try {
      const response = await academyService.exportToExcelDocuments(filters);
      const blob = new Blob([
        response.data,
    ]);

    const url =
        window.URL.createObjectURL(blob);

    const link =
        document.createElement("a");

    link.href = url;

    link.download = `comprobantes-${Moment().format('YYYY-MM-DD-H-m-s')}.xlsx`;

    link.click();

    window.URL.revokeObjectURL(url);
    } catch (error) {
      
    }
  };

  const updateFilters = (values) => {
    setFilters((prev) => ({
      ...prev,
      ...values,
      /*
            |--------------------------------------------------------------------------
            | Reinicia página
            |--------------------------------------------------------------------------
            */
      page: 1,
    }));
    setIsFilters(true);
  };

  const clearFilters = () => {
    setFilters(valInitials);
    setIsFilters(false);
  }
 
  useEffect(() => {
    setFilters((prev)=> ({
      ...prev,
      campus_id: campus.id,
      page: 1,
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campus]);

  const { documents, loading, meta } = useDocuments(filters);
  return (
    <>
      <div className="section-body">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center ">
            <div className="header-action">
              <h1 className="page-title">Comprobantes</h1>
              <ol className="breadcrumb page-breadcrumb">
                <li className="breadcrumb-item">
                  {props.user.school ? props.user.school : "YAKHANA"}
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Comprobantes
                </li>
              </ol>
            </div>
            <Nav tabs className="page-header-tab">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 1 })}
                  onClick={() => setActiveTab(1)}
                >
                  Comprobantes
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
      </div>
      <div className="section-body mt-4">
        <div className="container-fluid">
          <Container maxWidth={false} disableGutters>
            <Paper sx={{ p: 1, borderRadius: 2 }}>
              {/* Cabecera */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "end",
                  mb: 3,
                }}
              >
                {
                  isFilters && 
                  <Button
                    variant="contained"
                    color="success"
                    startIcon={<FileDownloadRounded />}
                    onClick={() => handleExport()}
                    sx={{ mr: 1 }}
                  >
                      Exportar a excel 
                  </Button>
                }
                <Button
                  variant="contained"
                  startIcon={<AddCircleOutlined />}
                  onClick={() => handleClick()}
                >
                  Nuevo Documento
                </Button>
              </Box>

              {/* Filtros */}
              <DocumentFilters
                filters={filters}
                updateFilters={updateFilters}
                setFilters={setFilters}
                clearFilters={clearFilters}
              />

              {/* Tabla de Datos */}
              <DocumentTable
                data={documents}
                meta={meta}
                loading={loading}
                filters={filters}
                setFilters={setFilters}
              />
            </Paper>
          </Container>
          {/* </TabPane>
          </TabContent> */}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => {
    return {
      user: state.user,
      campus: state.campus,
      filters: state.filters
    };
  };
  
  export default connect(mapStateToProps)(InvoicePage);

// export default InvoicePage;
